import { ref } from 'vue'

export function usePopUp() {
  const isPopupActive = ref(false)

  const openPopup = () => {
    isPopupActive.value = true
  }

  const closePopup = () => {
    isPopupActive.value = false
  }

  const togglePopup = () => {
    isPopupActive.value = !isPopupActive.value
  }

  return {
    isPopupActive,
    openPopup,
    closePopup,
    togglePopup,
  }
}
